/**
 * WeVideo-owned hosts that server-provided / user-supplied URLs are allowed to
 * redirect or navigate to. Wildcards use `*` for "any suffix". Single source of
 * truth shared by `@core`'s URLUtil and `@checkout`'s URLHelper.
 */
export const REDIRECT_WHITELIST = {
	WEVIDEO_DOMAIN: "https://www.wevideo.com/*",
	WEVIDEO_EU_DOMAIN: "https://eu.wevideo.com/*",
	WEVIDEO_STAGE_DOMAIN: "https://stage.wevideo.com/*",
	AWSTEST_DOMAIN: "https://awstest.wevideo.com/*",
	WEVIDEO_DOMAIN_RELATIVE_PROTOCOL: "//wevideo.com/*",
	AWSTEST_DOMAIN_RELATIVE_PROTOCOL: "//awstest.wevideo.com/*",
	LOCAL_HOST: "http://localhost*",
	LOCAL_HOST_HTTPS: "https://localhost*",
};

export const LOCALHOST_REDIRECT_TARGETS = [
	REDIRECT_WHITELIST.LOCAL_HOST,
	REDIRECT_WHITELIST.LOCAL_HOST_HTTPS,
];
